import clsx from "clsx";
import React, { ReactNode } from "react";

import { cn } from "utils/cn";

const FormRowInline = ({
  label,
  children,
  formRowClassName = "",
  leftLabelClassName = "",
  rightLabel = "",
  classRightLabel = "",
  error,
  isAlignRight = true,
  isLast = false,
  isPlural = false,
  leftLabel = false,
}: {
  label: string;
  children: ReactNode;
  formRowClassName?: string;
  leftLabelClassName?: string;
  rightLabel?: string;
  classRightLabel?: string;
  leftLabel?: string | ReactNode;
  error?: string | undefined;
  isAlignRight?: boolean;
  isLast?: boolean;
  isPlural?: boolean;
}) => {
  return (
    <div
      className={clsx(
        "flex items-center",
        isAlignRight ? "justify-between" : "justify-start",
        !isLast && "border-b border-normal pb-4",
        formRowClassName
      )}
    >
      {label && <span className={clsx("min-w-[96px]", isPlural && "self-start")}>{label}</span>}
      <div className="relative flex items-center gap-1">
        {leftLabel && <div className={cn("pr-6", leftLabelClassName)}> {leftLabel}</div>}
        <div className="flex flex-col">
          {children}
          {error && <span className="mt-2 text-xs font-bold text-attention">{error}</span>}
        </div>
        <span className={classRightLabel}>{rightLabel}</span>
      </div>
    </div>
  );
};

export default FormRowInline;
